import {Component, Input, OnInit} from '@angular/core';
import {ThemePalette} from '@angular/material/core';
import {GtAuthenticationService} from '@app/services/gt-authentication.service';
import {GtDirectoryService} from '@app/services/gt-directory.service';
import {GtNameValueService} from '@app/services/gt-name-value.service';
import {GtNotificationService} from '@app/services/gt-notification.service';
import {EndUserAccess} from '@gt-api';
import {forkJoin} from 'rxjs';

@Component({
  selector: 'gt-display-number-settings',
  templateUrl: './display-number-settings.component.html',
  styleUrls: ['./display-number-settings.component.scss']
})
export class DisplayNumberSettingsComponent implements OnInit {
  @Input() oname: string;
  @Input() login: string;
  @Input() canEdit = true;
  @Input() fullNumber: string;
  @Input() placeholder = 'display_number.title';
  @Input() color: ThemePalette;
  @Input() orientation: 'horizontal' | 'vertical' = 'vertical';
  showExtendedDisplayNumberChoices: boolean;
  displayNumberProfile: number;
  myNumber: string;

  constructor(
    protected nameValueService: GtNameValueService,
    protected notificationService: GtNotificationService,
    protected directoryService: GtDirectoryService,
    protected authenticationService: GtAuthenticationService
  ) {}

  ngOnInit() {
    this.oname = this.oname ? this.oname : this.authenticationService.oname;
    this.login = this.login ? this.login : this.authenticationService.login;

    this.directoryService.getEndUser(this.oname, this.login).subscribe(eu => {
      this.myNumber = eu.phoneNumber;
    });

    forkJoin([
      this.nameValueService.getEndUserNameValue('DisplayNumberProfile', this.oname, this.login),
      this.nameValueService.getEndUserNameValue('WorkHourDisplayNumberProfile', this.oname, this.login)
    ]).subscribe((result: string[]) => {
      this.displayNumberProfile = Number(result[0]);
      if (this.displayNumberProfile === 2 && result[1] === '1') {
        this.displayNumberProfile = 6;
      }
    }, this.error);
    this.directoryService.getEndUserAccess(this.oname, this.login).subscribe((endUserAccessList: EndUserAccess[]) => {
      const hasCategoryZero = endUserAccessList.some((endUserAccess: EndUserAccess) => endUserAccess.category === 0);
      const hasCategoryOne = endUserAccessList.some((endUserAccess: EndUserAccess) => endUserAccess.category === 1);
      this.showExtendedDisplayNumberChoices = hasCategoryZero && hasCategoryOne;
    });
  }

  updateDisplayNumberProfile() {
    this.displayNumberProfile = +this.displayNumberProfile;
    this.nameValueService
      .setEndUserNameValue('DisplayNumberProfile', this.displayNumberProfile.toString(), this.oname, this.login)
      .subscribe({
        error: this.error
      });
    if (this.displayNumberProfile === 2) {
      this.setWorkHourProfile(0);
    } else if (this.displayNumberProfile === 6) {
      this.setWorkHourProfile(1);
    }
  }

  private setWorkHourProfile(profile: number) {
    this.nameValueService.setEndUserNameValue('WorkHourDisplayNumberProfile', profile.toString(), this.oname, this.login).subscribe(() => {
      console.log('workingHoursDisplayNumberProfile updated: ' + profile);
    }, this.error);
  }

  private error = error => {
    this.notificationService.showErrorMessage(error);
  };
}
